import { useMemo } from "react";
import { encode } from "uqr";

/** Renders the QR code as one SVG path, so it scales crisply on a shared screen. */
export function QrCode({ value, className }: { value: string; className?: string }) {
	const { size, path } = useMemo(() => {
		const qr = encode(value, { ecc: "M", border: 2 });
		let d = "";
		qr.data.forEach((row, y) => {
			row.forEach((dark, x) => {
				if (dark) {
					d += `M${x} ${y}h1v1h-1z`;
				}
			});
		});
		return { size: qr.size, path: d };
	}, [value]);

	return (
		<svg
			viewBox={`0 0 ${size} ${size}`}
			className={className}
			shapeRendering="crispEdges"
			role="img"
			aria-label={`QR-Code zu ${value}`}
		>
			<rect width={size} height={size} fill="#ffffff" />
			<path d={path} fill="#0a2f43" />
		</svg>
	);
}
